<div
  class="container"
  [ngClass]="{
    flipped: flipped,
    'full-ability': settingsManager.settings.showFullAbilityCard || settingsManager.settings.showExpandedAbilityCard,
    'expanded-ability': settingsManager.settings.showExpandedAbilityCard && flipped,
    'bottom-actions': hasBottomActions && ability && secondAbility,
    'second-ability': secondAbility,
    fh: settingsManager.settings.fhStyle,
    disabled: !settingsManager.settings.abilities,
    denied:
      monster && gameManager.stateManager.permissions && !gameManager.stateManager.monsterPermissions[monster.name + '|' + monster.edition]
  }"
>
  @if (!secondAbility && !settingsManager.settings.showFullAbilityCard && !settingsManager.settings.showExpandedAbilityCard) {
    <div class="hover-effect initiative"></div>
  }
  @if (!secondAbility && !settingsManager.settings.showFullAbilityCard && !settingsManager.settings.showExpandedAbilityCard) {
    <div class="hover-effect title"></div>
  }
  <ghs-ability
    [ability]="ability"
    [monster]="monster"
    [flipped]="flipped"
    [activeActions]="monster.firstActiveAction ? (monster.firstActiveAction === 'bottom' ? 'bottom' : 'top') : false"
    [interactiveAbilities]="settingsManager.settings.interactiveAbilities"
    ghs-pointer-input
    (singleClick)="openAbilities($event)"
    (doubleClick)="openAbility($event)"
  ></ghs-ability>
  @if (!!secondAbility) {
    <ghs-ability
      [ability]="secondAbility"
      [monster]="monster"
      [flipped]="flipped"
      [activeActions]="monster.firstActiveAction ? (monster.firstActiveAction === 'bottom' ? 'top' : 'bottom') : false"
      [interactiveAbilities]="settingsManager.settings.interactiveAbilities"
      ghs-pointer-input
      (singleClick)="openAbilities($event)"
      (doubleClick)="openAbility($event)"
    >
    </ghs-ability>
  }

  @if (settingsManager.settings.abilities) {
    <span class="left-abilities"> {{ monster.abilities.length - drawnAbilities }}/{{ monster.abilities.length }} </span>
  }

  @if (settingsManager.settings.abilities && settingsManager.settings.monsterInitativeRange && minInitiative) {
    <span class="initiative-range">
      <span class="min">{{ minInitiative }}</span>
      @if (maxInitiative !== minInitiative) {
        <span class="spacer">-</span>
        <span class="max">{{ maxInitiative }}</span>
      }
    </span>
  }
</div>
